import React, { Component } from 'react';
import { connect } from 'react-redux';

// Layouts
import NavBar from '../layout/NavBar';
import loginCheck from '../login/LoginCheck';
import SponsorPoolsBody from './SponsorPoolsBody';

class DoctorPoolComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <NavBar />
        <SponsorPoolsBody />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  offlineConsult: state.offlineConsult,
});

export default connect(mapStateToProps)(loginCheck(DoctorPoolComponent));
